<span class="alert-text">{{ message?.text }}</span>
<button (click)="close()"></button>
